import { string, boolean, object, mixed } from "yup";

export const ProductMarqueSchema = object({
  libelle: object().shape({
    fr: string().required("Libellé (fr) obligatoire!!"),
 
  }),
  image: mixed().optional().nullable(),
  solde:boolean()
});
